__webpack_require__.p = "https://static.platzi.com/mf-learning//_next/";